import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 60000,
  withCredentials: true,
});

// ---- 401 → try one silent refresh, then bail ----
let _refreshPromise = null;
let _onUnauthorized = null;
export function setUnauthorizedHandler(fn) { _onUnauthorized = fn; }

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err?.config || {};
    const status = err?.response?.status;
    if (status !== 401 || orig._retried) throw err;

    // Skip auto-refresh on the auth endpoints themselves
    const url = (orig.url || "").toString();
    if (url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/signup")) {
      throw err;
    }

    orig._retried = true;
    try {
      _refreshPromise = _refreshPromise || api.post("/auth/refresh").finally(() => { _refreshPromise = null; });
      await _refreshPromise;
      return api.request(orig);
    } catch (e) {
      if (_onUnauthorized) _onUnauthorized();
      throw err;
    }
  },
);

// Standardise error messages — FastAPI 422 returns array of {msg,...}
export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return JSON.stringify(detail);
}
